import { render, staticRenderFns } from "./SOVDetailed.vue?vue&type=template&id=4c67c566&scoped=true"
import script from "./SOVDetailed.vue?vue&type=script&lang=js"
export * from "./SOVDetailed.vue?vue&type=script&lang=js"
import style0 from "./SOVDetailed.vue?vue&type=style&index=0&id=4c67c566&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c67c566",
  null
  
)

export default component.exports